import { THEME } from '@Theme';
import { CSSProperties, StyleSheet } from 'aphrodite';
import { NAV_BAR_WIDTH_COMPACT } from '../../constants/sizes';
import { brandSecondary, dashboardNavBackground } from '../../styles/colors';

const {
	common: { borderRadius },
	spacing: { xs, sm, md, xxl },
} = THEME;

const unreadTextMessageCount: CSSProperties = {
	alignItems: 'center',
	background: brandSecondary,
	borderRadius: '50%',
	color: '#fff',
	display: 'flex',
	justifyContent: 'center',
};

export const styleSheet = StyleSheet.create({
	compactUnreadTextMessageCount: {
		...unreadTextMessageCount,
		fontSize: 10,
		height: 14,
		width: 14,
	},
	header: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'center',
		padding: '40px 0',
	},
	link: {
		':hover': {
			backgroundColor: 'rgba(84, 160, 215, 0.26)',
			borderRadius,
		},
		':not(:first-child)': {
			marginTop: sm,
		},
		alignItems: 'center',
		boxSizing: 'border-box',
		color: 'white',
		display: 'flex',
		height: xxl,
		padding: `${xs}px ${md}px`,
		position: 'relative',
		textDecoration: 'none',
		width: '100%',
	},
	compactLinkPadding: {
		padding: `${xs}px ${sm}px`,
	},
	linkActive: {
		':before': {
			background: '#0095FF',
			content: '" "',
			display: 'block',
			height: 34,
			left: '-1rem',
			position: 'absolute',
			top: '50%',
			transform: 'translateY(-50%)',
			width: 6,
		},
		backgroundColor: 'rgba(84, 160, 215, 0.26)',
		borderRadius,
	},
	links: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		margin: sm,
	},
	logoContainer: {
		alignItems: 'center',
		color: '#aaa',
		display: 'flex',
		flexDirection: 'column',
		fontSize: 11,
		letterSpacing: '1.1px',
		marginBottom: 20,
		paddingTop: 20,
		textTransform: 'uppercase',
	},
	nav: {
		background: `radial-gradient(1000px 700px at 100% 0px, #040058 0%, rgba(0, 82, 140, 0.0001) 100%), radial-gradient(383px 607px at 100% 201px, rgba(255, 0, 133, 1) 0%, transparent 30%), ${dashboardNavBackground}`,
		boxShadow: '0px 0px 16px rgba(11, 34, 85, 0.600224)',
		height: '100%',
		minWidth: NAV_BAR_WIDTH_COMPACT,
		overflowX: 'hidden',
		overflowY: 'auto',
		position: 'relative',
		zIndex: 0,
	},
	unreadTextMessageCount: {
		...unreadTextMessageCount,
		fontSize: 12,
		height: 18,
		width: 18,
	},
});
